import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import OneClickButton from '../../components/form/button';
import { PanelPage } from '../../components/pages/pages';
import DualList from '../../components/pages/DualList';
import Form from '../../components/form/form';
import { generateReport } from '../../app/store/actions/reports';
import FilterDefault from '../../components/filters/FilterDefault';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';

class ReportMovementExpeditionOutboundList extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE41' /* Expedição */) },
      { value: I18n.t('BEE3316' /* Produtos pendentes para alocação */), active: true },
    ];

    this.options = [
      {
        label: I18n.t('BEE145' /* Filial */),
        table: 'outboundOrderProduct',
        value: 'branchCode',
        type: 'String',
      },
      {
        label: I18n.t('BEE2224' /* Data Integração */),
        table: 'outboundOrder',
        value: 'createdAt',
        type: 'String',
      },
      {
        label: I18n.t('BEE443' /* Documento */),
        table: 'outboundOrder',
        value: 'orderNumber',
        type: 'String',
      },
      {
        label: I18n.t('BEE1096' /* Pedido Cliente */),
        table: 'outboundOrder',
        value: 'customerOrderCode',
        type: 'String',
      },
      {
        label: I18n.t('BEE1687' /* Valor Total */),
        table: 'outboundOrder',
        value: 'totalValue',
        type: 'Number',
      },
      {
        label: I18n.t('BEE3921' /* Total da Mercadoria */),
        table: 'outboundOrder',
        value: 'orderValue',
        type: 'Number',
      },
      {
        label: I18n.t('BEE200' /* Tipo */),
        table: 'outboundOrder',
        value: 'orderType',
        type: 'String',
      },
      {
        label: I18n.t('BEE381' /* Código do Cliente */),
        table: 'outboundOrder',
        value: 'customerCode',
        type: 'String',
      },
      {
        label: I18n.t('BEE84' /* Razão Social */),
        table: 'customer',
        value: 'name',
        type: 'String',
      },
      {
        label: I18n.t('BEE463' /* Linha */),
        table: 'outboundOrderProduct',
        value: 'lineNumber',
        type: 'String',
      },
      {
        label: I18n.t('BEE378' /* Código do Produto */),
        table: 'product',
        value: 'productCode',
        type: 'String',
      },
      {
        label: I18n.t('BEE2170' /* Descrição Produto */),
        table: 'product',
        value: 'productName',
        type: 'String',
      },
      {
        label: I18n.t('BEE1756' /* Unidade de Medida */),
        table: 'product',
        value: 'unitMeasure',
        type: 'String',
      },
      {
        label: I18n.t('BEE1579' /* Lance Obrigatório */),
        table: 'outboundOrderProduct',
        value: 'mandatoryQuantity',
        type: 'Number',
      },
      {
        label: I18n.t('BEE2171' /* Quantidade Pedido */),
        table: 'outboundOrderProduct',
        value: 'quantity',
        type: 'Number',
      },
      {
        label: I18n.t('BEE530' /* Disponível */),
        table: 'stockBalance',
        value: 'available',
        type: 'Number',
      },
      {
        label: I18n.t('BEE182' /* Depósito */),
        table: 'stockBalance',
        value: 'depositCode',
        type: 'String',
      },
      {
        label: I18n.t('BEE267' /* Endereço */),
        table: 'stockBalance',
        value: 'addressCode',
        type: 'String',
      },
      {
        label: I18n.t('BEE2241' /* Quantidade Estoque */),
        table: 'stockBalance',
        value: 'stockQuantity',
        type: 'Number',
      },
      {
        label: I18n.t('BEE2008' /* Quantidade Alocada */),
        table: 'stockBalance',
        value: 'allocated',
        type: 'Number',
      },
      {
        label: I18n.t('BEE428' /* Lote */),
        table: 'stockBalance',
        value: 'lotNumber',
        type: 'String',
      },
      {
        label: I18n.t('BEE2398' /* Data de Validade */),
        table: 'stockBalance',
        value: 'expirationDate',
        type: 'String',
      },
      {
        label: I18n.t('BEE444' /* Data de Entrega */),
        table: 'outboundOrder',
        value: 'deliveryDate',
        type: 'String',
      },
    ];

    this.state = {
      selected: [],
      branchCodeFrom: '',
      branchCodeTo: '',
      createdAtFrom: '',
      createdAtTo: '',
      orderDateFrom: '',
      orderDateTo: '',
      orderNumberFrom: '',
      orderNumberTo: '',
      orderTypeFrom: '',
      orderTypeTo: '',
      customerCodeFrom: '',
      customerCodeTo: '',
      customerOrderCodeFrom: '',
      customerOrderCodeTo: '',
      productCodeFrom: '',
      productCodeTo: '',
    };
  }

  onChangeDualList = (selected) => {
    this.setState({ selected });
  };

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  onGenerateSpreadsheet = () => {
    const {
      selected,
      orderNumberFrom,
      orderNumberTo,
      orderTypeFrom,
      orderTypeTo,
      branchCodeFrom,
      branchCodeTo,
      customerCodeFrom,
      customerCodeTo,
      customerOrderCodeFrom,
      customerOrderCodeTo,
      productCodeFrom,
      productCodeTo,
      createdAtFrom,
      createdAtTo,
      orderDateFrom,
      orderDateTo,

    } = this.state;
    const { location } = this.props;

    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));

    const filters = returnFiltersByRules([
      ['branchCode', { type: 'between', value: [branchCodeFrom, branchCodeTo] }],
      ['orderNumber', {
        type: 'between',
        value: [orderNumberFrom, orderNumberTo],
        instance: 'OutboundOrder',
        as: 'outboundOrder',
      }],
      ['orderType', {
        type: 'between',
        value: [orderTypeFrom, orderTypeTo],
        instance: 'OutboundOrder',
        as: 'outboundOrder',
      }],
      ['customerCode', {
        type: 'between',
        value: [customerCodeFrom, customerCodeTo],
        instance: 'OutboundOrder',
        as: 'outboundOrder',
      }],
      ['customerOrderCode', {
        type: 'between',
        value: [customerOrderCodeFrom, customerOrderCodeTo],
        instance: 'OutboundOrder',
        as: 'outboundOrder',
      }],
      ['productCode', { type: 'between', value: [productCodeFrom, productCodeTo] }],
      ['createdAt', {
        type: 'between',
        value: [createdAtFrom, createdAtTo],
        instance: 'OutboundOrder',
        as: 'outboundOrder',
      }],
      ['orderDate', {
        type: 'between',
        value: [orderDateFrom, orderDateTo],
        instance: 'OutboundOrder',
        as: 'outboundOrder',
      }],
    ]);

    this.props.generateReport(
      I18n.t('BEE3316' /* Produtos pendentes para alocação */).toLowerCase(),
      'xlsx',
      location.pathname,
      headers,
      filters,
    );
  };

  onSelectFilter = (newState) => {
    this.setState({ ...newState });
  };

  render() {
    const {
      selected,
      orderNumberFrom,
      orderNumberTo,
      orderTypeFrom,
      orderTypeTo,
      branchCodeFrom,
      branchCodeTo,
      customerCodeFrom,
      customerCodeTo,
      productCodeFrom,
      productCodeTo,
      createdAtFrom,
      createdAtTo,

    } = this.state;

    const { location = {} } = this.props;

    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={`${I18n.t('BEE528' /* Relatório */)} - ${I18n.t('BEE3316' /* Produtos pendentes para alocação */)}`}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault stateToSave={this.state} route={location.pathname} onSelectFilter={this.onSelectFilter} />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <DualList
              id="dualselect"
              options={this.options}
              selected={selected}
              onChange={this.onChangeDualList}
              preserveSelectOrder
              showOrderButtons
              showHeaderLabels
            />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createInputRange(
                    { from: branchCodeFrom, to: branchCodeTo },
                    { from: 'branchCodeFrom', to: 'branchCodeTo' },
                    `${I18n.t('BEE145' /* Filial */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ), formContext.createInputRange(
                    { from: orderNumberFrom, to: orderNumberTo },
                    { from: 'orderNumberFrom', to: 'orderNumberTo' },
                    `${I18n.t('BEE443' /* Documento */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ), formContext.createInputRange(
                    { from: orderTypeFrom, to: orderTypeTo },
                    { from: 'orderTypeFrom', to: 'orderTypeTo' },
                    `${I18n.t('BEE200' /* Tipo */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createDateInputRange(
                    { from: createdAtFrom, to: createdAtTo },
                    { from: 'createdAtFrom', to: 'createdAtTo' },
                    `${I18n.t('BEE2224' /* Data Integração */)}:`,
                    { from: '', to: 'Z'.repeat(30) },
                  ),
                  formContext.createInputRange(
                    { from: customerCodeFrom, to: customerCodeTo },
                    { from: 'customerCodeFrom', to: 'customerCodeTo' },
                    `${I18n.t('BEE381' /* Código do Cliente */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createInputRange(
                    { from: productCodeFrom, to: productCodeTo },
                    { from: 'productCodeFrom', to: 'productCodeTo' },
                    `${I18n.t('BEE225' /* Produto */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                ])}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
        )}
        footerContent={(
          <OneClickButton
            type="button"
            style={{ width: 'auto', padding: 10 }}
            className="btn btn-primary p-5 m-5"
            onClick={this.onGenerateSpreadsheet}
          >
            {I18n.t('BEE544' /* Gerar Planilha */)}
          </OneClickButton>
        )}
      />
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  generateReport: (
    nameDoc,
    type,
    route,
    columns,
    filters,
  ) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportMovementExpeditionOutboundList);
